module.exports = "/_next/static/images/GainCompleteViewOfYourCustomers@2x-64ddd3c4af437f66befda471b25b20a5.webp";